module.exports = __webpack_public_path__ + "static/img/voice.c67d138e.svg";